import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useColumn } from '../columns/column-context';
import {
  HighlightContentBase,
  type HighlightElement,
  HighlightElementBase
} from './highlight-element-base';

export const BAR_HEIGHT = 17;

export function Bar({ ...forwardingProps }: HighlightElement) {
  const { highlightLabel: text } = useColumn();

  if (!text) {
    return null;
  }

  return (
    <Container {...forwardingProps}>
      <Content>{text}</Content>
    </Container>
  );
}

const Container = styled(HighlightElementBase).attrs({
  className: createReadableClass({ component: 'bar', element: 'container' })
})`
  height: ${BAR_HEIGHT}px;
`;

const Content = styled(HighlightContentBase).attrs({
  className: createReadableClass({ component: 'bar' })
})`
  height: 100%;
`;
